import { Type } from '@angular/core';
import { AbcConfiguration } from '@barthauer/abc/core/configuration';
import { QueryColumn } from '@barthauer/abc/core/data';
import { DataEntity, MapConfiguration } from '@barthauer/abc/graphics/adapters/open-layers';
import { ArenaSettingsViewModel } from '../viewModels/mapsData.viewModel';
import { Setting } from './setting.model';
import { ParameterValue } from '@barthauer/abc/queries/parameters/core';

export class BasysMapFrameConfiguration {
  globalConfig: AbcConfiguration;
  mapConfig: MapConfiguration;
  arenaCurrentSettings: ArenaSettingsViewModel;
  widgets: WidgetConfiguration[];
  visibleWidgets: () => ReadonlyArray<WidgetConfiguration>;
  routes: RouteConfiguration[];
  settings: Map<string, Setting>;
  groupedSettings: Map<string, Setting[]>;
  contextMenuCommands: Map<string, CommandConfig>;
  hasBackdrop: boolean;
  showImageSettingsTab: boolean;
  bottomSheetHeightPercentage: number;
  helpUrl: string;
  additionalObjectTypeConfigs: AdditionalObjectTypeConfig[];
  constructor() {
    this.widgets = new Array<WidgetConfiguration>();
    this.visibleWidgets = () =>
      this.widgets.filter((w) => w.svgIconName && (!w.visibleCondition || w.visibleCondition()));
    this.routes = new Array<RouteConfiguration>();
    this.settings = new Map<string, Setting>();
    this.groupedSettings = new Map<string, Setting[]>();
    this.contextMenuCommands = new Map<string, CommandConfig>();
    this.additionalObjectTypeConfigs = new Array<AdditionalObjectTypeConfig>();
    this.hasBackdrop = false;
    this.showImageSettingsTab = false;
    this.bottomSheetHeightPercentage = 60;
    this.helpUrl = 'http://help.barthauer.de/BaSYS/9.26.1/Web/maps/#t=02_BaSYS%2FA_BaSYS.htm';
  }

  public prepareSettings(): void {
    this.groupedSettings.clear();
    this.assignMissingSortOrders(this.settings);
    for (const setting of this.settings.values()) {
      if (setting.groupName) {
        if (!this.groupedSettings.get(setting.groupName)) {
          this.groupedSettings.set(setting.groupName, new Array<Setting>());
        }
        this.groupedSettings.get(setting.groupName).push(setting);
      } else {
        if (!this.groupedSettings.get('')) {
          this.groupedSettings.set('', new Array<Setting>());
        }
        this.groupedSettings.get('').push(setting);
      }
    }
  }
  private assignMissingSortOrders<K, V extends { sortOrder: number }>(map: Map<K, V>): void {
    const usedOrders = new Set<number>();
    let firstZeroFound = false;
    let nextFree = 1;

    // 1. Vorab: Alle vorhandenen sortOrders sammeln
    for (const value of map.values()) {
      if (value.sortOrder !== 0) {
        usedOrders.add(value.sortOrder);
      }
    }

    // 2. Iteriere in Einfügereihenfolge
    for (const value of map.values()) {
      if (value.sortOrder === 0) {
        if (!firstZeroFound) {
          // Die erste 0 bleibt bestehen
          firstZeroFound = true;
          continue;
        }

        // Finde nächste freie Zahl
        while (usedOrders.has(nextFree) || nextFree === 0) {
          nextFree++;
        }

        value.sortOrder = nextFree;
        usedOrders.add(nextFree);
        nextFree++;
      }
    }
  }
}

export class WidgetConfiguration {
  designation: string;
  componentType: Type<unknown>;
  svgIconName: string;
  visibleCondition: () => boolean;
  badgeValueExpression: () => string;
  route: RouteConfiguration;
}

export class RouteConfiguration {
  designation: string;
  outlet: string;
  path: string;
  constructor(initObj?: any) {
    Object.assign(this, initObj);
  }
}

export class CommandConfig {
  designation: string;
  action: any;
  badgeValueExpressionParameters?: ParameterValue[];
  enabledExpressionParameters?: ParameterValue[];
  isOnlineOnly?: boolean;
  isHidden?: () => boolean;

  constructor() {}
}

export class AdditionalObjectTypeConfig {
  objectTypeName: string;
  oPathFilter: string;
  filterParameters: ParameterValue[];
  additionalColumns?: QueryColumn[];
  navigateObjectIdColumnName: string;
  navigateObjectTypeColumnName: string;
  constructor(initObj?: any) {
    Object.assign(this, initObj);
  }
}

export class BasysMapFrameInitConfig {
  isStandalone?: boolean;
  mapsPath?: string;
  mapsOutlet?: string;
  isLimitedVersion?: boolean;
  preselectedDataEntities?: DataEntity[];
}
